<template>
    <div>
        <b-modal
            :id="modalId"
            modal-class="modal-confirm-redeem"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-close" v-if="showIconClose">
                    <img src="@/assets/icon/ic-close-black.svg" alt="ic-close" @click="clickCancel()" />
                </div>
                <div class="modal-base-img" v-if="showImage">
                    <img class="modal-base-img-confirm" src="@/assets/images/modal/img-confirm-modal.png" alt="img-confirm-modal">
                </div>
                <div class="modal-base-head"
                    v-if="lblConfirm.headline">
                    <p id="horizontal_headline" class="headline" v-html="lblConfirm.headline"></p>
                </div>
                <div class="modal-base-body">
                    <p id="horizontal_message" class="message" v-html="lblConfirm.message"></p>
                </div>
                <div class="modal-base-footer">
                    <div class="confirm-modal-btn-row">
                        <div class="confirm-modal-btn">
                            <PrimaryButton
                                btnId="confirm_redeem_confirm_btn"
                                :btnMsg="lblConfirm.btnPrimary"
                                @clickButton="clickConfirm()" />
                        </div>
                        <div class="confirm-modal-btn">
                            <SecondaryButton
                                btnId="confirm_redeem_cancel_btn"
                                :btnMsg="lblConfirm.btnSecondary"
                                @clickButton="clickCancel()" />
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
// components
import SecondaryButton from "@/components/Button/SecondaryButton.vue";
import PrimaryButton from "@/components/Button/PrimaryButton.vue";
export default {
    name: "HorizontalConfirm",
    components: {
        SecondaryButton,
        PrimaryButton
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        lblConfirm: Object,
        modalId: String,
        showImage: {
            type: Boolean,
            default: false
        },
        showIconClose: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        //event
        clickConfirm: function () {
            this.$emit("clickConfirm", { tag: "horizontal-confirm", id: this.modalId });
        },
        clickCancel: function () {
            this.$emit("clickCancel", { tag: "horizontal-confirm", id: this.modalId });
        },
        //modal
        show: function () {
            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    }
}
</script>
<style lang="scss">
@import "./ConfirmRedeemModal.scss";
</style>
